import { createAsyncThunk } from '@reduxjs/toolkit'
import { ROUTE_PATHS } from 'utils/constants/index'
import { getGamificationDataService } from 'network/services/gamification.service'

export const getGamificationData = createAsyncThunk('gamification/get-data', async (data, thunkApi) => {
  try {
    const res = await getGamificationDataService(data)
    return res
  } catch (error) {
    history.push(ROUTE_PATHS.error)
    return thunkApi.rejectWithValue(error[0].description)
  }
})

